import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  return (
    <>
      <SiteHeader />
      <main className="mx-auto flex w-full min-h-[64vh] flex-col items-center justify-center px-4 py-24 text-center">
        <p className="font-heading text-[72px] font-bold leading-none text-background-300 md:text-[110px]">
          404
        </p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
          这一页暂时没有内容
        </h1>
        <p className="mt-3 max-w-md text-sm leading-7 text-foreground-600">
          你访问的页面可能已经下线或链接有误。可以回到首页，或者直接去看看今天的热瓜。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line text-base" aria-hidden="true" />
            返回首页
          </Link>
          <Link
            to="/hot"
            className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            浏览热门大瓜
          </Link>
        </div>
      </main>
      <SiteFooter />
    </>
  );
}